module.exports = __webpack_public_path__ + "img/GAME_GLACIER.16db5aef.png";